const observe = {
  inserted: function(el, binding, vnode) {
    const callback = entries => {
      const entry = entries[0]
      if (entry.isIntersecting) {
        if (vnode.child) {
          // directive is attached on vue component
          vnode.child.$emit('seen')
        } else {
          // directive is attached on DOM element
          vnode.data.on.seen()
        }
        el.observer.unobserve(el)
      }
    }
    el.observer = new IntersectionObserver(callback)
    el.observer.observe(el)
  }
}

/**
 * This observes visibility on the component where it is attached.
 * When component is available in the viewport, it emits an event - @seen
 */
export default observe
